export const DRIVER_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  changeAddress: {
    streetAddress: 'Street Address',
    zipCode: 'Zip Code',
    apt: 'Apartment#',
    city: 'City',
    state: 'State',
    isVehiclesStayOvernight: 'Will all your vehicles be kept overnight at this new address?',
    effectDate: 'What date would you like this change to go into effect?',
    dateOfChange: 'When did/will you move to this address?',
    vehiclesStayOvernightAddress: {
      streetAddress: 'Street Address',
      zipCode: 'Zip Code',
      apt: 'Apartment#',
      city: 'City',
      state: 'State'
    },
    memberChangeAddress: 'Will your household members change at the new address?'
  }
}
